/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import {createApi} from "@reduxjs/toolkit/query/react";
import customFetchBase from "../lib/redux/customFetchBase.ts";
import {Statistic} from "../types/statistics";

export interface StatisticsResponse {
    data: Statistic[];
    status: string;
    items: number;
}

export const statisticsApi = createApi({
    reducerPath: 'statisticsApi',
    baseQuery: customFetchBase,
    tagTypes: ['Statistic'],
    endpoints: (builder) => ({
        getStatistics: builder.query<Statistic[], void>({
            query() {
                return {
                    url: `/statistic/`,
                    credentials: 'include',
                };
            },
            transformResponse: (result: StatisticsResponse) =>
                result.data,
            providesTags: (_result, _error) => [{type: 'Statistic'}],
        }),
    })
});

export const {
    useGetStatisticsQuery,
} = statisticsApi;
